import React from 'react';
import {
  VARIABLE_TYPE_CHOICES,
  variableTypeLabel,
  variableTypeOf,
} from '../../../../utils/variableTypeChange';

const TypeSelect = ({ variable, readOnly, onChange }) => {
  const type = variableTypeOf(variable);
  if (readOnly) {
    return (
      <span className="variables-panel__type-label">{variableTypeLabel(type)}</span>
    );
  }
  return (
    <select
      className="variables-panel__type-select"
      value={type}
      aria-label="Variable type"
      onChange={(e) => onChange?.(e.target.value)}
    >
      {VARIABLE_TYPE_CHOICES.map((choice) => (
        <option key={choice.type} value={choice.type}>
          {choice.label}
        </option>
      ))}
    </select>
  );
};

export default TypeSelect;
